export default "__VITE_ASSET__C39T5gMl__"